<!-- 逻辑详解 -->
<template>
    <div style="width: 100%">
        <H3Title :title="'逻辑详解'"></H3Title>

        <div id="wwave" style="width: 100%; height: 300px"></div>
    </div>
</template>

<script>
import H3Title from '@/components/H3Title'
import waterWave from '../pages/pc/utils/WaterWave'
export default {
    name: 'LogicDetail',
    components: {
        H3Title,
    },
    props: {
        elementId: {
            type: String,
            default: 'hello',
        },
        drawData: {
            type: Object,
            default: function () {
                return {}
            },
        },
    },
    watch: {
        drawData: {
            handler(newvalue, oldvalue) {
                if (newvalue.HGData) {
                    this.init()
                }
            },
        },
    },
    // data() {
    //   return {
    //     chart: {}
    //   };
    // },
    methods: {
        getValue(d, returnColor) {
            if (d >= 0.7) {
                return returnColor ? 'red' : 0.8
            } else if (d < 0.7 && d >= 0.3) {
                return returnColor ? 'yellow' : 0.5
            } else {
                return returnColor ? 'blue' : 0.15
            }
        },
        init() {
            let { HGData, currencyLiquidity, marketEstimation, logEstimation, dualMarketValue, dualTurnover, M1, DR007 } = this.drawData
            let projectColors = this.$chartConfigs.projectColors
            let lineColor = '#4e4e4e'

            let data = {
                nodeData: [
                    {
                        name: '宏观数据',
                        percentile: HGData && HGData.percentile ? this.getValue(HGData.percentile) : 0.4,
                        color: projectColors[this.getValue(HGData.percentile, true)],
                    },
                    {
                        name: '市场估值',
                        percentile: this.getValue(marketEstimation.percentile),
                        color: projectColors[this.getValue(marketEstimation.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: '指数估值',
                        percentile: this.getValue(logEstimation.percentile),
                        color: projectColors[this.getValue(logEstimation.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: '两市总市值',
                        percentile: this.getValue(dualMarketValue.percentile),
                        color: projectColors[this.getValue(dualMarketValue.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: '货币流动性',
                        percentile: currencyLiquidity && currencyLiquidity.percentile ? this.getValue(currencyLiquidity.percentile) : 0.1,
                        color: projectColors[this.getValue(currencyLiquidity.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: '两市成交额',
                        percentile: this.getValue(dualTurnover.percentile),
                        color: projectColors[this.getValue(dualTurnover.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: 'M1',
                        percentile: this.getValue(M1.percentile),
                        color: projectColors[this.getValue(M1.percentile, true)],
                        lineColor: lineColor,
                    },
                    {
                        name: 'DR007',
                        percentile: this.getValue(DR007.percentile),
                        color: projectColors[this.getValue(DR007.percentile, true)],
                        lineColor: lineColor,
                    },
                ],
            }

            let option = {
                //球的半径
                ballDiameter: 74,
                // 球边框的配置
                ballBorder: {
                    color: '#333438',
                    width: 2,
                },
                waveInterval: 2,
                animateRunTime: 10,
                // 球文字的配置
                ballLabel: {
                    color: '#fff',
                    fontSize: 12,
                },
                //字体大小和颜色
                itemLabel: {
                    fontSize: 12,
                    color: '#fff',
                },
                // 虚线线宽,颜色
                line: {
                    width: 1,
                    color: '#006DB9',
                },

                //svg的背景颜色
                background: '#202126',
                //指定绑定的div的id，svg会注入这个容器
                bindingDivId: 'wwave',
                //数据
                data: data,
                //画布离svg上边缘的距离
                topPadding: 80,
                //图片上下两边的贝塞尔曲线的弯曲程度，越大则越向外拐
                bezierAngle: 20,
                //因为左边的球位置关系不一样，所以做了特殊处理。这边指定这个球是哪个球。
                originName: '宏观数据', //设计中最左边的那个球，所有边最终指向的那个点
            }

            // ball-width 67  height 250
            let ww = new waterWave(option)
            ww.draw()

            window.addEventListener('resize', function () {
                ww.resize()
            })
        },
    },
    mounted() {
        if (!this.drawData.HGData) return
        this.init()
    },
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
</style>
